const container = document.querySelector('#Product-Slider');
const galleryContainer = document.querySelector('.akb-media-gallery');
const stickyButton = document.querySelector('.geenee-try-on-btn');

const dots = document.querySelector('#akb-image-dots')
const BUTTON_WIDTH = 136;

function setMobilePosition() {
  if (!container || !stickyButton) return;
  
  const isIpad = () =>
  /iPad/.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  const _isTablet = () =>
  /Tablet|iPad|PlayBook|Silk|(Android(?!.*Mobile))/i.test(navigator.userAgent);

  const isTablet = isIpad() || _isTablet();
  
  if (!isTablet){
    const top = dots.getBoundingClientRect().top - 60;
    stickyButton.style.top = top + 16 + 'px';    
  } else {
    const height = galleryContainer?.clientHeight || 0;
    const bottomOffset = 52;  
    stickyButton.style.top = height - bottomOffset + 'px';    
  }
 
  stickyButton.style.position = 'absolute';
  stickyButton.style.left = (window.innerWidth - BUTTON_WIDTH )/ 2 + 'px';
}


let isUpdating = false;

function updateDesktopButtonPosition() {
  if (!container || !stickyButton) return;

  const scrollY = window.scrollY;
  const containerRect = container.getBoundingClientRect();
  const containerTop = containerRect.top + scrollY;
  const containerBottom = containerTop + containerRect.height - 20;
  const bottomOffset = 24;
  
  let targetTop = window.innerHeight - stickyButton.offsetHeight - bottomOffset + scrollY;
  targetTop = Math.max(targetTop, containerTop);
  targetTop = Math.min(targetTop, containerBottom - stickyButton.offsetHeight);

  const targetLeft = containerRect.left + (containerRect.width - BUTTON_WIDTH )/ 2;

  stickyButton.style.position = 'fixed';
  stickyButton.style.left = `${Math.round(targetLeft)}px`;
  stickyButton.style.top = `${Math.round(targetTop - scrollY)}px`;

  isUpdating = false;
}


function throttledUpdate() {
  if (!isUpdating) {
    isUpdating = true;
    requestAnimationFrame(updateDesktopButtonPosition);
  }
}

const isMobile = window.innerHeight > window.innerWidth;
document.addEventListener('DOMContentLoaded', () => {
     if (isMobile){
      setMobilePosition();
    } else {
      throttledUpdate();
      window.addEventListener('scroll', throttledUpdate, { passive: true });
      window.addEventListener('resize', throttledUpdate);
    }

    stickyButton.style.display = 'flex';
   
});



